import { TabContext, TabList } from "@mui/lab";
import {
  Box,
  Grid,
  IconButton,
  styled,
  Tab,
  TableCell,
  tableCellClasses,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataNotFound from "../Components/Common/DataNotFound";
import CustomPagination from "../Components/Common/CommonPagination";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  create_posts,
  deleteTicket,
  getTicket,
  update_post,
  uploadImage,
} from "../Redux/Actions/action";
import ErrorHandler, { CommonStatusChip } from "../Utils/handler";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { BucketURL } from "../ApiSetup/Api";
import ButtonContained from "../Components/Common/ButtonContained";
import CommonTextField from "../Components/Common/CommonTextField";
import CustomDialog from "../Components/Common/CustomDialog";
import CommonFileUpload from "../Components/Common/CommonFileUpload";
import TextLabel from "../Components/Common/CommonTextLabel";
import Assets from "../Components/Common/Assets";
import EditIcon from "@mui/icons-material/Edit";
import CommonTable from "../Components/Common/CommonTable";
import { showLoader } from "../Redux/Slices/loaderSlice";
import dayjs from "dayjs";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme?.palette?.bgLightWhite?.main,
    fontSize: 14,
    // fontWeight: "bold",
    textAlign: "center", // Horizontally align content,
    lineHeight: "1.2rem",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "10px 10px !important",
    textAlign: "center", // Horizontally align content
    borderBottom: "2px solid #d9d6f3",
  },
}));

const HelpDesk = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("0");
  const [data, setData] = useState({});
  const [helpDeskData, setHelpDeskData] = useState({});
  console.log("helpDeskData", helpDeskData);

  const [error, setError] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const tabData = [
    { label: "Open Tickets", value: "0", color: theme.palette.primary.main },
    { label: "Closed Tickets", value: "1", color: theme.palette.primary.main },
  ];

  const _getTicket = async () => {
    dispatch(showLoader(true));
    let body = {
      type: value == 0 ? "Open" : "Closed",
      page: page,
      limit: rowsPerPage,
    };
    try {
      const result = await dispatch(getTicket(body));
      const error = ErrorHandler(result);
      if (error) {
        console.log("result", result);

        setHelpDeskData(result?.payload?.data);
      }
    } catch (error) {
      console.log("getTicket", error);

      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _deleteTicket = async (id) => {
    dispatch(showLoader(true));
    try {
      const result = await dispatch(deleteTicket({ _id: id }));
      const error = ErrorHandler(result);
      if (error) {
        toast.success(result?.payload?.message);
        _getTicket();
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const handleClear = () => {
    setOpen(false);
    setIsEdit(false);
    setData({});
    setError({});
  };

  // --------------- handleChange ---------------
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value.trimStart() });
  };

  const validation = () => {
    let isValid = true;
    let error = {};
    if (!data.memberName) {
      error.memberName = "Member Name is required";
      isValid = false;
    }
    if (!data.memberImage) {
      error.memberImage = "Member Image is required";
      isValid = false;
    }
    if (!data.memberDesignation) {
      error.memberDesignation = "Member Designation is required";
      isValid = false;
    }
    setError(error);
    return isValid;
  };

  const handleImageUpload = async (e) => {
    const { files, name } = e?.target;

    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    const validTypes = [...validImageTypes];

    const fileData = files[0];
    if (!validTypes.includes(fileData.type)) {
      setError((error) => ({
        ...error,
        memberImageSize:
          "Invalid file type. Only JPEG, PNG and JPG are allowed.",
      }));
      return;
    }

    if (fileData.size > 10485760) {
      setError((error) => ({
        ...error,
        memberImageSize:
          "File size exceeds the 10 MB limit. Please upload a smaller file.",
      }));
      return;
    }

    const formData = new FormData();
    formData.append("image", files[0]);

    dispatch(showLoader(true));
    try {
      const result = await dispatch(uploadImage(formData));
      const error = ErrorHandler(result);

      if (error) {
        const uploadedFile = result?.payload?.data?.[0]?.image;

        setData((prevState) => ({
          ...prevState,
          [name]: uploadedFile,
          isImage: validImageTypes.includes(fileData.type),
        }));

        setError((error) => ({
          ...error,
          memberImageSize: "",
          bannerImage: "",
        }));
      }
    } catch (err) {
      console.error("File upload failed:", err);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _createUpdatePosts = async () => {
    if (validation()) {
      dispatch(showLoader(true));
      try {
        let body = {
          type: "Office-Member",
          officeMember: {
            memberImage: data?.memberImage,
            memberDesignation: data?.memberDesignation,
            memberName: data?.memberName,
            memberType:
              value == 0
                ? "Office-Bearer"
                : value == 1
                ? "Margdarshak-Member"
                : "Karobari-Member",
          },
        };
        if (isEdit && data?._id) {
          body._id = data?._id;
        }
        const fn = isEdit ? update_post : create_posts;
        const result = await dispatch(fn(body));
        const error = ErrorHandler(result);
        if (error) {
          toast.success(result?.payload?.message);
          _getTicket();
          handleClear();
        }
      } catch (error) {
        toast.error(error?.message || "An unknown error occurred");
      } finally {
        dispatch(showLoader(false));
      }
    }
  };

  useEffect(() => {
    _getTicket();
  }, [value, page, rowsPerPage]);

  const headerList = [
    "No",
    "Ticket Number",
    "Requester Name",
    "PPSK ID",
    "Title",
    "Date & Time",
    "Document",
    "Status",
    value == 0 ? "Action" : "",
  ];

  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography sx={{ fontSize: "20px", fontWeight: 500, mb: 2 }}>
          Help Desk
        </Typography>
      </Box>
      <TabContext value={value}>
        <Box mb={1}>
          <TabList
            onChange={(e, newValue) => {
              if (newValue !== undefined) {
                setValue(newValue);
                setPage(1);
              }
            }}
            aria-label="tabs with icons"
            sx={{
              "& .MuiTabs-indicator": {
                display: "none",
              },
              "& .Mui-selected": {
                background: tabData?.filter((e) => e?.value == value)?.[0]
                  ?.color,
                color: `${theme.palette.common.white} !important`,
              },
            }}
          >
            {tabData?.map((tab) => {
              return (
                <Tab
                  label={`${tab?.label}`}
                  value={tab?.value}
                  sx={{
                    marginRight: "10px",
                    border: `2px solid ${tab.color}`,
                    borderRadius: "10px",
                    color: tab.color,
                    height: "40px",
                    minHeight: "0px",
                  }}
                />
              );
            })}
          </TabList>
        </Box>
        <Grid item xs={12}>
          <CommonTable headerList={headerList?.filter((e) => e)} isNotSorting>
            {helpDeskData?.response?.length > 0 ? (
              helpDeskData?.response?.map((item, index) => (
                <TableRow key={index}>
                  <StyledTableCell align="center">
                    {(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.ticketNumber}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.userDetails?.fullName}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.userDetails?.ppskId}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.subject}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {dayjs(item?.createdAt).format("DD MMM YYYY hh:mm A")}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.userDetails?.ppskId}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {<CommonStatusChip label={item?.status} />}
                  </StyledTableCell>
                  {value == 0 && (
                    <StyledTableCell align="center">
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={1}
                        justifyContent={"center"}
                      >
                        <IconButton
                          sx={{ padding: 0 }}
                          onClick={() => {
                            setOpen(true);
                            setIsEdit(true);
                            setData({
                              _id: item?._id,
                              memberName: item.officeMember?.memberName,
                              memberDesignation:
                                item?.officeMember?.memberDesignation,
                              memberImage: item?.officeMember?.memberImage,
                            });
                          }}
                        >
                          <EditIcon fontSize="small" color="success" />
                        </IconButton>
                        <IconButton
                          sx={{ padding: 0 }}
                          onClick={() => {
                            _deleteTicket(item?._id);
                          }}
                        >
                          <DeleteIcon fontSize="small" color="error" />
                        </IconButton>
                      </Box>
                    </StyledTableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableCell colSpan={8}>
                  <DataNotFound
                    title={"No Records Found"}
                    icon={
                      <ErrorOutlineIcon
                        color="primary"
                        style={{ fontSize: "3rem" }}
                      />
                    }
                    elevation={0}
                  />
                </StyledTableCell>
              </TableRow>
            )}
          </CommonTable>
          {helpDeskData?.count > 0 && (
            <Grid item xs={12}>
              <CustomPagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                count={Math.ceil(helpDeskData?.count / rowsPerPage)}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          )}
        </Grid>
      </TabContext>
    </div>
  );
};

export default HelpDesk;
